import DownloadIcon from "assets/icons/Clients_Flow_Icons/childHeaderIcons/DownloadIcon";
import MessageIcon from "assets/icons/Clients_Flow_Icons/childHeaderIcons/MessageIcon";
import WhatsAppicon from "assets/icons/Clients_Flow_Icons/childHeaderIcons/WhatsAppicon";
import ClientDynamicModal from "components/ui/ClientFlowModals/ClientDynamicModal";
import Tooltip from "components/ui/Tooltip";
import { useContext, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { ReactComponent as Sort } from "assets/icons/sort.svg";
import { ReactComponent as Filter } from "assets/filter/filter.svg";
import SortContext from "context/SortContext";
import { Box, CircularProgress, IconButton, styled, Typography } from "@mui/material";
import Button from "components/ui/Button";
import { useCatalogSettingContext } from "context/CatalogSettingContext";
import { useClientContext } from "context/ClientContext";
import { getIcon } from "utils/iconsConfig";
import { ReactComponent as ExpiryDateCalendar } from "assets/icons/Clients_Flow_Icons/Red_Calendar.svg";
import apiClient from "lib/api-client";
import { findSpecificMenu, findSpecificSubMenu, isAllowed } from "utils/checkUserRigths";
import { usePermissions } from "context/PermissionsContext";
import { formatCurrency, formatShortAmount } from "utils/formatCurrency";
import { useQuery } from "@tanstack/react-query";

const StyledButton = styled(Button)(({ theme, bgcolor, style }) => ({
  width: style?.width ? style?.width : "100%",
  fontFamily: "Karla",
  fontWeight: style?.weight ? style?.weight : 500,
  padding: style?.padding ? style?.padding : "10px",

  fontSize: "18px",
  lineHeight: "21.5px",
  height: "41px",
  borderRadius: "5px",
  color: bgcolor ? bgcolor : "#ffffff",
  border: `1px solid ${bgcolor ? bgcolor : " #ffffff"} `,
  textTransform: "none",
  backgroundColor: "transparent",
  "&:hover": {
    backgroundColor: bgcolor ? bgcolor : "#ffffff",
    color: "black",
  },
  "&.Mui-disabled": {
    backgroundColor: "transparent",
    color: "#8B8B8B",
    border: "1px solid #8B8B8B",
  },
}));

function StatCard({ label, value, valueColor = "#FFFFFF", icon = null }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#1A1A1A",
        borderRadius: "8px",
        padding: "7px 16px",
        minWidth: "130px",
        gap: "2px",
        border: "1px solid #2E2E2E",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
        {icon && <span style={{ fontSize: "13px", lineHeight: 1 }}>{icon}</span>}
        <Typography
          sx={{
            fontFamily: "Poppins, sans-serif",
            fontWeight: 600,
            fontSize: "14px",
            color: valueColor,
            lineHeight: "1.4",
            whiteSpace: "nowrap",
          }}
        >
          {value}
        </Typography>
      </Box>
      <Typography
        sx={{
          fontFamily: "Poppins, sans-serif",
          fontWeight: 400,
          fontSize: "11px",
          color: "#777777",
          lineHeight: "1.3",
          whiteSpace: "nowrap",
          textAlign: "center",
        }}
      >
        {label}
      </Typography>
    </Box>
  );
}
const fetchDuesAndLedger = async (clientCode) => {
  const { data } = await apiClient.get(
    `/api/v9/myBinnys/getDuesAndLedger?clientCode=${clientCode}`
  );
  return data?.data?.data;
};

const ClientIconChild = () => {
  const location = useLocation();
  const { sortOptions } = useContext(SortContext);
  const { setTimeSpentCatalogOpen } = useCatalogSettingContext();
  const { timeSpentBtn, renewBtn, showBagIcon, showExpiryTimer, bagCount, diaWeight, goldWeight } = useClientContext();
  const state = location?.state;
  const { clientId } = useParams();

  const [modalType, setModalType] = useState({
    open: false,
    type: "",
  });

  const [loadingDownload, setLoadingDownload] = useState(false);

  const permissions = usePermissions();
  const hasAccessToDues_LedgerShare = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Dues & Ledger"), "share");
  const hasAccessToDues_LedgerDownload = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Dues & Ledger"), "download");
  const isDues = state && Object.prototype.hasOwnProperty.call(state, "allDues");
  const isLedger = state?.ledger;

  const { data: duesData } = useQuery({
    queryKey: ["duesAndLedger", clientId],
    queryFn: () => fetchDuesAndLedger(clientId),
    enabled: !!clientId && !!isDues,
  });

  const billedDues = duesData?.totalDuesClosingBalance ?? 0;
  const currentDues = duesData?.totalDuesBalance ?? 0;
  const totalWeight = duesData?.totalUnfixWeight ?? 0;
  // const unfixGold = duesData?.unfixGold ?? 0;

  const handleDownload = async () => {
    try {
      setLoadingDownload(true);

      const response = await apiClient(`/api/v9/myBinnys/allLedgerForVision/pdf?clientCode=${clientId}`);

      if (response?.data?.status === 200 && response.data.data) {
        window.open(response.data.data, "_blank");
      }
    } catch (error) {
      console.error("Error downloading PDF:", error);
    } finally {
      setLoadingDownload(false);
    }
  };

  const handleModalOpen = (modalType) => {
    setModalType({
      open: true,
      type: modalType,
    });
  };

  const handlTimeSpentCatalog = () => {
    setTimeSpentCatalogOpen(true);
  };

  return (
    <>
      <div className="child-header-icon">
        {(isDues || isLedger) && (
          <>
            {isDues && (
              <Box sx={{ display: "flex", alignItems: "center", gap: "8px", mr: "8px" }}>
                <StatCard
                  label="Billed Dues"
                  value={`${formatCurrency(billedDues)}`}
                  valueColor="#FFFFFF"
                />
                <StatCard
                  label="Current Dues"
                  value={`${formatCurrency(currentDues)}`}
                  valueColor="#50C878"
                />
                <StatCard
                  label="Unfix Gold"
                  value={`${formatShortAmount(totalWeight)}`}
                  valueColor="#FFFFFF"
                  icon={getIcon("GoldBar")}
                />
              </Box>
            )}
            {/* ─────────────────────────────────────────────────────────────── */}

            {hasAccessToDues_LedgerShare && (
              <Tooltip title="Whatsapp BA report">
                <div
                  onClick={() => {
                    setModalType({
                      open: true,
                      type: "WhatsAppBA",
                    });
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <WhatsAppicon height={"35px"} width={"35px"} />
                </div>
              </Tooltip>
            )}

            <Tooltip title="Email BA report">
              <div
                onClick={() => {
                  setModalType({
                    open: true,
                    type: "EmailBA",
                  });
                }}
                style={{ cursor: "pointer" }}
              >
                <MessageIcon height={"35px"} width={"35px"} />
              </div>
            </Tooltip>

            {/* <Tooltip title="Download BA report">
              <div
                // onClick={() => {
                //   setModalType({
                //     open: true,
                //     type: "Download",
                //   });
                // }}
                style={{ cursor: "pointer" }}
              >
                <DownloadIcon height={"35px"} width={"35px"} />
              </div>
            </Tooltip> */}

            {hasAccessToDues_LedgerDownload && (
              <Tooltip title="Download BA report">
                <div onClick={handleDownload} style={{ cursor: loadingDownload ? "not-allowed" : "pointer" }}>
                  {loadingDownload ? <CircularProgress size={25} /> : <DownloadIcon height={"35px"} width={"35px"} />}
                </div>
              </Tooltip>
            )}
          </>
        )}
        {showBagIcon && (
          <div style={{ display: "flex", gap: "20px" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                padding: "5px 16px",
                background: "#0D0D0D",
                fontFamily: "Karla",
                fontWeight: 500,
                fontSize: "12px",
                lineHeight: "20px",
                gap: "10px",
                borderRadius: "5px",
              }}
            >
              <span style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "7px", background: "#262626", borderRadius: "50%" }}>{getIcon("RedBag")}</span>
              Bag : <span style={{ fontFamily: "Poppins", fontWeight: 500, fontSize: "14px" }}>{bagCount}</span>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                padding: "5px 16px",
                background: "#0D0D0D",
                fontFamily: "Karla",
                fontWeight: 500,
                fontSize: "12px",
                lineHeight: "20px",
                gap: "10px",
                borderRadius: "5px",
              }}
            >
              <span style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "7px", background: "#262626", borderRadius: "50%" }}>{getIcon("Small_Diamond")}</span>
              Diamond Wt : <span style={{ fontFamily: "Poppins", fontWeight: 500, fontSize: "14px" }}>{diaWeight.toFixed(4)} Ct</span>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                padding: "5px 16px",
                background: "#0D0D0D",
                fontFamily: "Karla",
                fontWeight: 500,
                fontSize: "12px",
                lineHeight: "20px",
                gap: "10px",
                borderRadius: "5px",
              }}
            >
              <span style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "7px", background: "#262626", borderRadius: "50%" }}>{getIcon("GoldBar")}</span>
              Gold Wt : <span style={{ fontFamily: "Poppins", fontWeight: 500, fontSize: "14px" }}>{goldWeight.toFixed(4)} g</span>
            </div>
          </div>
        )}

        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "24px" }}>
          {showExpiryTimer && (
            <div className="child-header-create-btn" style={{ width: "auto", height: "40px", backgroundColor: "#0D0D0D", borderRadius: "5px", padding: "16px 16px", gap: "5px" }}>
              <IconButton sx={{ p: "0px" }}>
                <ExpiryDateCalendar />
              </IconButton>
              <div style={{ display: "flex", justifyContent: "space-between", gap: "5px", alignItems: "center" }}>
                <span style={{ fontSize: "12px", fontWeight: "400", fontFamily: "karla" }}>Expiring :</span>
                <Typography sx={{ fontFamily: "poppins", fontWeight: "500", fontSize: "14px" }}>{state?.expiryDate}</Typography>
              </div>
            </div>
          )}

          {timeSpentBtn && (
            <div className="child-header-create-btn">
              <StyledButton onClick={handlTimeSpentCatalog} disableRipple disableFocusRipple>
                Total Time Spent on Catalog
              </StyledButton>
            </div>
          )}
        </div>

        {renewBtn && (
          <StyledButton disableRipple disableFocusRipple bgcolor={"#676b69ff"} style={{ width: "auto", weight: "400", padding: "10px", pointerEvents: "none" }}>
            Renew Access
          </StyledButton>
        )}

        {!timeSpentBtn && sortOptions?.length > 0 && (
          <Tooltip title="Sort By">
            <IconButton disableRipple disableFocusRipple>
              <Sort />
            </IconButton>
          </Tooltip>
        )}
      </div>

      <ClientDynamicModal
        open={modalType.open}
        handleClose={() => setModalType({ ...modalType, open: false })}
        onClick={() => setModalType({ ...modalType, open: false })}
        modalType={modalType.type}
        type={isDues ? "Dues" : "Ledger"}
      />
    </>
  );
};

export default ClientIconChild;
